module.exports = __webpack_public_path__ + "static/media/icon-image-crop-zoom-in.f55bffe6.svg";